function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, React.createElement("path", {
  id: "elderly_icon_svg__a",
  d: "M140.22 1585.223v18.548c0 .467-.436.853-.972.853s-.972-.386-.972-.853v-18.548c0-.736-.683-1.338-1.53-1.338-.835 0-1.521.602-1.521 1.338 0 .468-.44.85-.972.85-.536 0-.972-.382-.972-.85 0-1.25.86-2.31 2.082-2.78-2.46-3.209-3.83-6.747-4.565-9.7l-4.436 11.026c-.004.007-.018.013-.022.016.16.473 2.894 8.938-.35 18.529-.325.965-1.33 1.582-2.419 1.582-.236 0-.479-.028-.718-.09-1.337-.345-2.101-1.58-1.704-2.752 2.58-7.632.754-14.636.397-15.852-2.741-4.686-3.273-9.011-1.576-12.863 2.708-6.149 10.143-8.58 10.457-8.684 1.304-.42 2.766.175 3.237 1.322.168.405.114 1.357.114 1.442 0 .078.093 8.477 5.191 14.655.476.58.472 1.326.065 1.902.714.555 1.186 1.345 1.186 2.247z"
}), React.createElement("path", {
  id: "elderly_icon_svg__b",
  d: "M143.18 1560.009c0 2.769-2.212 5.016-4.928 5.016-2.728 0-4.942-2.247-4.942-5.016 0-2.776 2.214-5.009 4.942-5.009 2.716 0 4.928 2.233 4.928 5.009z"
}));

var _ref2 = /*#__PURE__*/React.createElement("use", {
  fill: "#a2a2a2",
  xlinkHref: "#elderly_icon_svg__a",
  transform: "translate(-119 -1555)"
});

var _ref3 = /*#__PURE__*/React.createElement("use", {
  fill: "#a2a2a2",
  xlinkHref: "#elderly_icon_svg__b",
  transform: "translate(-119 -1555)"
});

var SvgElderlyIcon = function SvgElderlyIcon(props) {
  return React.createElement("svg", _extends({
    width: 25,
    height: 50,
    viewBox: "0 0 25 50"
  }, props), _ref, _ref2, _ref3);
};

export default SvgElderlyIcon;